import type { ChallengeInfo, QuizChallenge } from "../challenges/api/getChallengesForEmployee";
import type { Question } from "./types";

export function isQuizChallenge(challenge: ChallengeInfo): challenge is QuizChallenge {
    return challenge.challengeType === "quiz";
}

export function assertQuizChallenge(challenge: ChallengeInfo): asserts challenge is QuizChallenge {
    if (!isQuizChallenge(challenge)) throw new Error("Challenge is not a quiz");
}

export function getTopic(quiz: QuizChallenge, question: Question) {
    return quiz.metadata.questionList.find((q) => q.questionId === question?.questionId)?.topic;
}

export function getTotalQuestions(quiz: QuizChallenge) {
    return quiz.metadata?.questionList.length ?? 0;
}

export function getCorrectAnswers(quiz: QuizChallenge) {
    return quiz.answeredQuestions?.filter((answer) => answer.isCorrectAnswer).length ?? 0;
}

export function isQuizDone(quiz: QuizChallenge, totalQuestions: number, correctAnswers: number): boolean {
    const now = new Date();
    const deadline = new Date(quiz.deadline);

    return totalQuestions === correctAnswers || now > deadline;
}
